module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"logo_alt":"Logo Footer","copy_right":"Copyright {copy} Fundación Organización VID - Desarrollado por ","designed":"Designed by ","logo_footer_alt":"Logo Cadena Apps"}}')
  delete Component.options._Ctor
}
